import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { ExploreImage, HttpResponse } from "@/types";

export const exploreImagesQueryKey = ["explore-images"] as const;

export function useGetExploreImages() {
  return useQuery({
    queryKey: exploreImagesQueryKey,
    queryFn: async () => {
      const res = await guacHttpClient.get<
        ExploreImage[],
        HttpResponse<ExploreImage[]>
      >("explore-images");
      return res.data;
    },
  });
}
